import { render, staticRenderFns } from "./bank-transactions-list.vue?vue&type=template&id=1611136f"
import script from "./bank-transactions-list.vue?vue&type=script&lang=js"
export * from "./bank-transactions-list.vue?vue&type=script&lang=js"
import style0 from "./bank-transactions-list.vue?vue&type=style&index=0&id=1611136f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports